var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"send-button"},[_c('a-button',{attrs:{"type":"primary","size":"large"},on:{"click":() => _vm.$emit('deletePaymentData')}},[_vm._v(_vm._s(_vm.$t('Delete the data')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }